import { GMAIL_TRACKING_LOCATION } from '../../../services/tracking/getTrackingLocation';
import { allTrackers } from '../../../services/tracking/tracking';

export const EMAIL_AGENT_SECTION = 'AI Outreach in gmail';

type EmailMode = 'reply' | 'compose new';

export const initEmailAgentTracking = () => {
  allTrackers.trackPageView({
    path: {
      page_id: 'email_agent',
      section: EMAIL_AGENT_SECTION,
      sub_section: '',
      sub_sub_section: '',
    },
    is_sw_user: false,
    lang: 'en',
    custom_data: { action: `see on ${GMAIL_TRACKING_LOCATION}` },
  });
};

const getEmailMode = (instanceId?: string): EmailMode => {
  return instanceId?.includes('inline') ? 'reply' : 'compose new';
};

const dispatchTrackEvent = (action: string, eventName: string, instanceId?: string) => {
  allTrackers.dispatchTrackEvent('craft email agent', action, eventName, {
    location: GMAIL_TRACKING_LOCATION,
    email_mode: getEmailMode(instanceId),
  });
};

const trackGmailToolbarAction = (eventSubName: string, eventSubSubName?: string, instanceId?: string) => {
  dispatchTrackEvent(
    'click',
    `gmail toolbar icon/${eventSubName}${eventSubSubName ? `/${eventSubSubName}` : ''}`,
    instanceId
  );
};

const trackGmailAssistantAction = (eventSubName: string, eventSubSubName?: string, instanceId?: string) => {
  dispatchTrackEvent(
    'click',
    `gmail assistant/${eventSubName}${eventSubSubName ? `/${eventSubSubName}` : ''}`,
    instanceId
  );
};

export const emailAgentTracking = {
  trackOpenEmailAgentWithRecipient: (instanceId?: string) => {
    trackGmailToolbarAction('load email preview', 'with recipient', instanceId);
  },

  trackOpenEmailAgentWithoutRecipient: (instanceId?: string) => {
    trackGmailToolbarAction('load gmail assistant', 'no recipient', instanceId);
  },

  trackTypeInBubble: (inputTextValues: string, instanceId?: string) => {
    trackGmailAssistantAction(inputTextValues, undefined, instanceId);
  },

  trackCreateEmail: (inputTextValues: string, instanceId?: string) => {
    trackGmailAssistantAction('Create email', inputTextValues, instanceId);
  },

  trackGenerateEmail: (instanceId?: string) => {
    dispatchTrackEvent('click', `generate email`, instanceId);
  },

  trackInsertEmail: (instanceId?: string) => {
    trackGmailAssistantAction('Insert email', undefined, instanceId);
  },

  trackRegenerateEmail: (instanceId?: string) => {
    trackGmailAssistantAction('Regenerate email', undefined, instanceId);
  },

  trackCancelEmail: (hasEmailPreview: boolean, instanceId?: string) => {
    trackGmailAssistantAction('Remove email', hasEmailPreview ? 'cancel preview' : 'cancel bubble', instanceId);
  },

  trackError: (errorMessage: string, instanceId?: string) => {
    trackGmailAssistantAction('Error', errorMessage, instanceId);
  },

  trackOpenEmailAgentAfterLogin: (instanceId?: string) => {
    trackGmailAssistantAction('Bubble loaded', undefined, instanceId);
  },

  trackLoginInitiated: (instanceId?: string) => {
    const isReplyMode = instanceId?.includes('inline');
    trackGmailToolbarAction('login initiated', isReplyMode ? 'with recipient' : 'no recipient', instanceId);
  },

  trackCopyPreview: (instanceId?: string) => {
    trackGmailAssistantAction('manual copy', undefined, instanceId);
  },
};
